/* Houdt de verwijzingen naar de handleiding gelijk aan de gekozen uitvoering.

   Bij het laden van de pagina klopt alles: Liquid rendert het pad van de
   variant die in de url staat. Klikt de bezoeker daarna een andere uitvoering
   aan, dan vernieuwt Shopify alleen het bovenste productblok. De knop onder de
   stappen, de zin in de kenmerken en het antwoord in de FAQ bleven zo naar de
   handleiding van de vórige uitvoering wijzen, en bij de piramide bleven ook de
   zes stappen die van de andere maat.

   Het Earthle-thema lost dit op door per maat een eigen knop te renderen en de
   andere te verbergen. Dat kan hier niet: twee van de drie verwijzingen staan
   midden in een lopende zin. Wat ik er wel van overneem is dat de keuze
   rechtstreeks uit de knoppen wordt gelezen, en niet uit de url of uit een
   melding van het thema. Die kunnen achterlopen of ontbreken; de aangevinkte
   knop niet.

   Twee dingen gebeuren er bij een wissel:
   - elke link die naar het oude handleidingpad wees, gaat naar het nieuwe;
   - de instructiesectie wordt opnieuw opgehaald bij Shopify, zodat ook de
     stappen kloppen. Lukt dat niet, dan is de link dankzij de eerste stap
     alsnog goed.

   De paden komen kant-en-klaar uit Liquid en staan dus al in de taal van de
   markt. Er wordt hier niets zelf in elkaar geplakt. */
(function () {
  if (window.koperoHandleidingVariant) return;
  window.koperoHandleidingVariant = true;

  var kaart = null;

  function lees() {
    if (kaart) return kaart;
    var el = document.querySelector('[data-kopero-handleidingen]');
    if (!el) return null;
    try {
      kaart = JSON.parse(el.textContent || '{}');
    } catch (fout) {
      return null;
    }
    return kaart;
  }

  /* De aangevinkte knoppen zijn de betrouwbaarste bron: hun waarde is woord
     voor woord de varianttitel, dus vergelijken kan zonder omzetten. Eerder
     ging dat mis met het Duitse "Groß", dat in de sleutel "gross" heette. */
  function idUitKeuze() {
    if (!kaart || !kaart.opties) return null;
    var vs = document.querySelector('variant-selects');
    if (!vs) return null;

    var waarden = [];
    var groepen = vs.querySelectorAll('fieldset, .product-form__input--dropdown');
    for (var i = 0; i < groepen.length; i++) {
      var veld = groepen[i].querySelector('input:checked, select');
      if (veld) waarden.push(veld.value);
    }
    if (!waarden.length) {
      var aangevinkt = vs.querySelector('input[type="radio"]:checked');
      if (aangevinkt) {
        waarden.push(aangevinkt.value);
      } else {
        var keuzelijst = vs.querySelector('select');
        if (keuzelijst) waarden.push(keuzelijst.value);
      }
    }
    if (!waarden.length) return null;

    var sleutel = waarden.join(' / ');
    if (kaart.opties[sleutel]) return kaart.opties[sleutel];

    /* Terugval: soms staat er onzichtbare witruimte omheen. */
    var kaal = sleutel.replace(/\s+/g, ' ').trim();
    for (var naam in kaart.opties) {
      if (naam.replace(/\s+/g, ' ').trim() === kaal) return kaart.opties[naam];
    }
    return null;
  }

  function idUitUrl() {
    var m = /[?&]variant=(\d+)/.exec(window.location.search);
    return m ? m[1] : null;
  }

  function zetLinks(nieuw) {
    if (!nieuw || !kaart || nieuw === kaart.huidig) return;
    var oud = kaart.huidig;
    var links = document.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].getAttribute('href') === oud) links[i].setAttribute('href', nieuw);
    }
    kaart.huidig = nieuw;
  }

  /* De instructiesectie opnieuw ophalen. Shopify geeft met section_id de
     gerenderde sectie terug voor precies deze variant, dus stappen, kop en knop
     komen in één keer goed, in elke taal. */
  function verversInstructies(id) {
    var sectie = document.querySelector('[data-kopero-instructies]');
    if (!sectie || !id) return;
    var sid = sectie.getAttribute('data-kopero-instructies');
    if (!sid) return;
    var url =
      window.location.pathname +
      '?variant=' + encodeURIComponent(id) +
      '&section_id=' + encodeURIComponent(sid);

    fetch(url)
      .then(function (antwoord) {
        return antwoord.ok ? antwoord.text() : null;
      })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var vers = doc.querySelector('[data-kopero-instructies]');
        if (vers) sectie.innerHTML = vers.innerHTML;
      })
      .catch(function () {});
  }

  function bijwerken(id) {
    if (!lees()) return;
    var gekozen = id || idUitKeuze() || idUitUrl();
    if (!gekozen) return;
    var paden = kaart.paden || {};
    zetLinks(paden[String(gekozen)]);
    verversInstructies(gekozen);
  }

  /* Een klik kan de url pas even later bijwerken, en het thema vervangt soms
     de knoppen. Daarom een paar keer kijken in plaats van één keer. */
  function probeer() {
    [0, 120, 350, 800, 1500].forEach(function (ms) {
      setTimeout(function () {
        bijwerken(null);
      }, ms);
    });
  }

  function start() {
    if (!lees()) return;

    /* De keuzeknoppen zelf. Dit is de hoofdweg en werkt ook als het thema geen
       meldingen uitzendt. */
    document.addEventListener('change', function (gebeurtenis) {
      var doel = gebeurtenis.target;
      if (doel && doel.closest && doel.closest('variant-selects')) {
        probeer();
      }
    });

    /* Dawn meldt de wissel ook zelf, met het hele variantobject erbij. Dubbelop,
       maar het vangt de gevallen op waarin de variant zonder klik verandert. */
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (gebeurtenis) {
        var v = gebeurtenis && gebeurtenis.data && gebeurtenis.data.variant;
        var id = v && v.id ? String(v.id) : null;
        setTimeout(function () {
          bijwerken(id);
        }, 0);
      });
    }

    window.addEventListener('popstate', function () {
      setTimeout(function () {
        bijwerken(null);
      }, 0);
    });

    /* Eén keer bij het laden, voor het geval de pagina uit een cache komt waarin
       een andere variant stond dan nu is aangevinkt. */
    bijwerken(null);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
